import { create } from "zustand"
import { persist } from 'zustand/middleware';

const useRefreshStore = create()(
    persist(
        (set) => ({
            hasRefreshed: false,
            setHasRefreshed: (state) => set({ hasRefreshed: state }),
        }),
        { name: 'refresh-store'}
    )
);

export default useRefreshStore;
